import { usePays } from "@/hooks/usePays";
import { usePaysFiltre } from "@/lib/paysFilter";
import { useI18n } from "@/lib/i18n";
import type { PaysDto } from "@/types/pays.types";

/** Liste des pays enregistrés, sur une seule ligne avec défilement horizontal,
 * sous le menu principal — sélectionner un ou plusieurs pays filtre les
 * articles affichés (aucune sélection = tous les pays). */
export function CountryBar() {
  const { locale, t } = useI18n();
  const { data } = usePays();
  const { paysIds, togglePaysId, clearPaysIds } = usePaysFiltre();

  const paysList: PaysDto[] = (Array.isArray(data) ? data : [])
    .filter((p) => p.actif)
    .sort((a, b) => (a.ordre ?? 0) - (b.ordre ?? 0));

  if (paysList.length === 0) return null;

  return (
    <div className="border-b border-rule bg-surface/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex items-center gap-2 overflow-x-auto py-2">
          <button
            onClick={clearPaysIds}
            className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
              paysIds.length === 0
                ? "bg-foreground text-background"
                : "border border-border text-muted-foreground hover:text-foreground"
            }`}
          >
            {t("countryBar.all")}
          </button>
          {paysList.map((p) => (
            <button
              key={p.id}
              onClick={() => togglePaysId(p.id)}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
                paysIds.includes(p.id)
                  ? "bg-foreground text-background"
                  : "border border-border text-muted-foreground hover:text-foreground"
              }`}
            >
              {locale === "fr" ? p.nom : (p.nomEn || p.nom)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
